<template>
  <div class="space-bottom">
    <div class="transblack-background"/>
    <jFloatingPrompt
      ref="titleFloating"
      class="p__b--100">
      <b-row class="jobTitleFloat">
        <b-col>
          <h3>Create Flow SLA</h3>
          <!-- eslint-disable-next-line -->
          <b-form-group :class="{ 'error-input' : $v.flow_sla.flow.$error }">
            <label>Name *</label>
            <j-single-select
              v-model="$v.flow_sla.flow.$model"
              :options="null"
              value-format="object"
              placeholder="name"
              label="name"/>
          </b-form-group>
          <b-form-group :class="{'error-input' : $v.flow_sla.duration.$error}">
            <label>Duration (minutes) *</label>
            <j-input
              v-model="$v.flow_sla.duration.$model"
              :max-length="25"
              type="number"
              placeholder="Duration"/>
          </b-form-group>
          <!-- <b-form-group :class="{'error-input' : $v.flow_sla.sla.$error}"> -->
          <div class="c--blue">SLA Indicator</div>
          <br>
          <div
            v-for="(type, index) in $v.flow_sla.sla.$each.$iter"
            :key="type.type">
            <b-row>
              <b-col cols="3">
                <div class="m__t--10">
                  <j-checkbox
                    v-model="type.is_check"
                    :checked="is_visible"
                    :disabled="false"
                    :checked-value="true"
                    :unchecked-value="false">
                    Type {{ Number(index) + 1 }}
                  </j-checkbox>
                </div>
              </b-col>
              <b-col>
                <b-form-group :class="{'error-input' : type.value.$error}">
                  <j-input
                    v-model="type.value.$model"
                    :max-length="25"
                    type="number"
                    placeholder="Duration"/>
                </b-form-group>
              </b-col>
            </b-row>

          </div>
          <!-- </b-form-group> -->
        </b-col>
        <b-col cols="2">
          <!-- button create -->
          <div class="wrap-button-flow">
            <b-button
              class="btn blue"
              @click="createDivision">
              SUBMIT
            </b-button>
            <i
              class="fa fa-times"
              @click="$refs.titleFloating.hide('/organigram')"/>
          </div>
        </b-col>
      </b-row>
    </jFloatingprompt>
  </div>

</template>

<script>
import jFloatingPrompt from '@/components/new-floating-templete/jFloatingPrompt';
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
// eslint-disable-next-line
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import apiUser from '@/services/jApiUser';
import apiPositionLayer from '@/services/jApiPositionLayer';

export default {
  components: {
    jFloatingPrompt,
  },
  data() {
    return {
      flow_sla: {
        flow: null,
        duration: null,
        sla: [
          {
            is_check: false,
            type: 1,
            value: null,
          },
          {
            is_check: false,
            type: 2,
            value: null,
          },
          {
            is_check: false,
            type: 3,
            value: null,
          },
        ],
      },
    };
  },
  validations: {
    flow_sla: {
      flow: {
        required,
      },
      duration: {
        required,
      },
      sla: {
        $each: {
          value: {
            required,
          },
        },
      },
    },
  },
  computed: {
    ...mapState('jStoreFlows', ['divisions_list', 'users_list']),
    err_message() {
      if (!this.$v.v_add_title.name.required) {
        return 'Field is required';
      } else if (!this.$v.v_add_title.name.minLength) {
        return 'Minimum 3 characters';
      }
      return 'Field is required';
    },
    save_title() {
      let divisions = null;
      if (this.v_add_title.divisions !== null) {
        divisions = this.v_add_title.divisions.map(val => val.id);
      }
      return {
        user_company_id: this.v_add_title.email ? this.v_add_title.email.id : '',
        name: this.v_add_title.name,
        description: '',
        code: this.v_add_title.code,
        divisions: divisions !== null ? divisions : [],
        position_layer: this.v_add_title.position_layer ? this.v_add_title.position_layer : '',
      };
    },
  },
  watch: {
    // eslint-disable-next-line
    'v_add_title.code': function (val) {
      const upperCase = val.toUpperCase();
      this.v_add_title.code = upperCase;
    },
  },
  created() {
    this.getListDivisions();
  },
  methods: {
    ...mapActions('jStoreOrganigram', ['createNewDivision', 'createNewTitle']),
    ...mapActions('jStoreFlows', ['getListDivisions']),
    createDivision() {
      this.$v.v_add_title.$touch();
      if (!this.$v.v_add_title.$error) {
        this.$refs.titleFloating.hide('/organigram');
        setTimeout(() => {
          this.createNewTitle(this.save_title);
        }, 250);
      }
    },

    loadOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'email',
          },
        };
        this.getListUsers(reqData, callback);
      }
    },

    async getListUsers(req, callback) {
      let apiUserData;

      if (req.pagination.query.length >= 3) {
        apiUserData = await apiUser.listUser(req);
      } else {
        apiUserData = [];
      }

      if (typeof apiUserData !== 'undefined') {
        apiUserData.forEach((lab, index) => {
          apiUserData[index].label = lab.email;
        });
      }
      callback(null, apiUserData);
      return apiUserData;
    },

    loadOptionsLayer({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
          },
        };
        this.getListLayer(reqData, callback);
      }
    },

    async getListLayer(req, callback) {
      let apiPositionLayerData;

      if (req.pagination.query.length >= 3) {
        apiPositionLayerData = await apiPositionLayer.getPositionLayerList(req);
      } else {
        apiPositionLayerData = [];
      }
      if (typeof apiPositionLayerData !== 'undefined') {
        apiPositionLayerData.forEach((lab, index) => {
          apiPositionLayerData[index].label = lab.name;
        });
      }
      callback(null, apiPositionLayerData);
      return apiPositionLayerData;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/flow-rule/flow/flow-sla/create/jCreateFlowSLA.vue